/** Atarim's public status page — partners report uptime against it (agreement 8.12). */
export const STATUS_PAGE_URL = 'https://stats.uptimerobot.com/RKLEWfGk0W'
